import Link from "next/link";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from "@reach/accordion";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Separator, Text } from "@nju/ui";

export function AdditionalInfo() {
  return (
    <Accordion collapsible={true} multiple={true}>
      <AccordionItem className="bg-white rounded-[12px] border-[2px] border-geyser p-4 from-tablet:py-4">
        <AccordionButton className="bg-transparent border-none flex items-center cursor-pointer [&[aria-expanded='true']_svg]:rotate-0">
          <div className="flex items-center">
            <Icon
              className="mr-3 shrink-0 w-4 h-4 rotate-180"
              name="chevron-up"
              tone="neutral"
            />
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "l",
              }}
            >
              co dalej po instalacji?
            </Text>
          </div>
        </AccordionButton>
        <AccordionPanel className="ml-7">
          <Separator size="xs" tone="invisible" />
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            Jeśli masz podpiętą kartę lub zapłaciłeś/zapłaciłaś podczas
            składania zamówienia, Twoja usługa zacznie działać od razu po
            instalacji. Jeśli nie - nie zwlekaj z płatnością. Podepnij kartę lub
            zapłać, korzystając z płatności online lub BLIK.
          </Text>
          <Separator size="xs" tone="invisible" />
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            Pamiętaj, że do czasu opłacenia usługi korzystanie z internetu nie
            będzie możliwe.{" "}
            <Link
              href={portalRoutes.mojeKonto.platnosci.index.get()}
              passHref={true}
            >
              <A display="inline" size="inline" variant="simple">
                <Text withUnderline={true}>Przejdź do płatności</Text>
              </A>
            </Link>
          </Text>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
